var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('f7-app',{attrs:{"params":_vm.$root.f7params}},[_c('f7-view',{attrs:{"url":_vm.url,"main":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }